export default __webpack_public_path__ + "static/decor-26d08d81731b2f051406b11f183ea46c.svg";